import { LoadingAnimation } from '../view/loading-animation/loading-animation'
import styles from './loading-page.module.css'

export const LoadingPage = () => {
    return <div className={styles.loadingPage}>Loading...</div>
}